import React, { useState, useEffect } from "react";
import Lottie from "lottie-react";

import "./AnalyzeBriefLoader.scss";

const loadingStateText = [
  "Extracting key details from your brief",
  "Analyzing creator requirements",
  "Reviewing campaign goals and brand context",
  "Looking for matching audience profiles",
  "Identifying relevant creator categories",
  "Applying filters based on your brief",
  "Refining search to match your campaign tone and goals",
];

const animationData = {
  nm: "Main Scene",
  ddd: 0,
  h: 48,
  w: 48,
  meta: { g: "@lottiefiles/creator 1.46.2" },
  layers: [
    {
      ty: 4,
      nm: "Path 1 Container",
      sr: 1,
      st: 0,
      op: 150,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [28.000014781951904, 28.037513256072998] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: {
          a: 1,
          k: [
            {
              o: { x: 0.167, y: 0.167 },
              i: { x: 0.833, y: 0.833 },
              s: [52, 52],
              t: 0,
            },
            {
              o: { x: 0.167, y: 0.167 },
              i: { x: 0.833, y: 0.833 },
              s: [24, 24],
              t: 12,
            },
            { s: [52, 52], t: 24 },
          ],
        },
        r: { a: 0, k: -360 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          bm: 0,
          hd: false,
          nm: "Path 1",
          d: 1,
          ks: {
            a: 0,
            k: {
              c: true,
              i: [
                [0, 0],
                [-0.9895000000000014, 2.9685200000000007],
                [0, 0],
                [-0.2516999999999996, -0.7552800000000004],
                [0, 0],
                [-2.968499999999999, -0.9895000000000014],
                [0, 0],
                [0.7553000000000019, -0.2516999999999996],
                [0, 0],
                [0.9895000000000014, -2.968499999999999],
                [0, 0],
                [0.2516999999999996, 0.7553000000000019],
                [0, 0],
                [2.9685200000000007, 0.9895000000000014],
                [0, 0],
                [-0.75529, 0.2516999999999996],
                [0, 0],
              ],
              o: [
                [2.9685200000000007, -0.9895000000000014],
                [0, 0],
                [0.2516999999999996, -0.75529],
                [0, 0],
                [0.9895000000000014, 2.9685200000000007],
                [0, 0],
                [0.7553000000000019, 0.2516999999999996],
                [0, 0],
                [-2.968499999999999, 0.9895000000000014],
                [0, 0],
                [-0.2516999999999996, 0.7553000000000019],
                [0, 0],
                [-0.9895000000000014, -2.968499999999999],
                [0, 0],
                [-0.75529, -0.2516999999999996],
                [0, 0],
                [0, 0],
              ],
              v: [
                [6.3366, 12.624],
                [12.624, 6.3366],
                [13.2141, 4.56647],
                [14.7859, 4.56646],
                [15.376, 6.3366],
                [21.6634, 12.624],
                [23.4335, 13.2141],
                [23.4335, 14.7859],
                [21.6634, 15.376],
                [15.376, 21.6634],
                [14.7859, 23.4335],
                [13.2141, 23.4335],
                [12.624, 21.6634],
                [6.3366, 15.376],
                [4.56647, 14.7859],
                [4.56647, 13.2141],
                [6.3366, 12.624],
              ],
            },
          },
        },
        {
          ty: "fl",
          bm: 0,
          hd: false,
          nm: "Fill",
          c: { a: 0, k: [0.7059, 0.7137, 0.7451] },
          r: 1,
          o: { a: 0, k: 100 },
        },
        {
          ty: "fl",
          bm: 0,
          hd: false,
          nm: "Fill",
          c: { a: 0, k: [0.7059, 0.7137, 0.7451] },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 1,
    },
    {
      ty: 4,
      nm: "Path 2 Container",
      sr: 1,
      st: 0,
      op: 150,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [28.000014781951904, 28.037513256072998] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: {
          a: 1,
          k: [
            {
              o: { x: 0.167, y: 0.167 },
              i: { x: 0.833, y: 0.833 },
              s: [12, 12],
              t: 0,
            },
            {
              o: { x: 0.167, y: 0.167 },
              i: { x: 0.833, y: 0.833 },
              s: [24, 24],
              t: 12,
            },
            { s: [12, 12], t: 24 },
          ],
        },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          bm: 0,
          hd: false,
          nm: "Path 2",
          d: 1,
          ks: {
            a: 0,
            k: {
              c: true,
              i: [
                [0, 0],
                [-1.7810999999999986, 5.343299999999999],
                [0, 0],
                [-0.4532000000000025, -1.3595000000000006],
                [0, 0],
                [-5.343299999999999, -1.7811999999999983],
                [0, 0],
                [1.359499999999997, -0.4532000000000025],
                [0, 0],
                [1.7811000000000021, -5.343299999999999],
                [0, 0],
                [0.4532000000000025, 1.359499999999997],
                [0, 0],
                [5.343299999999999, 1.7811000000000021],
                [0, 0],
                [-1.3595000000000006, 0.4532000000000025],
                [0, 0],
              ],
              o: [
                [5.343299999999999, -1.7811999999999983],
                [0, 0],
                [0.4532000000000025, -1.3595000000000006],
                [0, 0],
                [1.7811000000000021, 5.343299999999999],
                [0, 0],
                [1.359499999999997, 0.4532000000000025],
                [0, 0],
                [-5.343299999999999, 1.7811000000000021],
                [0, 0],
                [-0.4532000000000025, 1.359499999999997],
                [0, 0],
                [-1.7810999999999986, -5.343299999999999],
                [0, 0],
                [-1.3595000000000006, -0.4532000000000025],
                [0, 0],
                [0, 0],
              ],
              v: [
                [20.2059, 31.5233],
                [31.5232, 20.2059],
                [32.5853, 17.0196],
                [35.4147, 17.0196],
                [36.4768, 20.2059],
                [47.7941, 31.5233],
                [50.9804, 32.5853],
                [50.9804, 35.4147],
                [47.7941, 36.4768],
                [36.4768, 47.7941],
                [35.4147, 50.9804],
                [32.5853, 50.9804],
                [31.5232, 47.7941],
                [20.2059, 36.4768],
                [17.0196, 35.4147],
                [17.0196, 32.5853],
                [20.2059, 31.5233],
              ],
            },
          },
        },
        {
          ty: "fl",
          bm: 0,
          hd: false,
          nm: "Fill",
          c: { a: 0, k: [0.7059, 0.7137, 0.7451] },
          r: 1,
          o: { a: 0, k: 100 },
        },
        {
          ty: "fl",
          bm: 0,
          hd: false,
          nm: "Fill",
          c: { a: 0, k: [0.7059, 0.7137, 0.7451] },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 2,
    },
  ],
  v: "5.7.0",
  fr: 30,
  op: 30,
  ip: 0,
  assets: [],
};

export default function AnalyzeBriefLoader() {
  const [index, setIndex] = useState(0);
  const [fadeProp, setFadeProp] = useState({
    fade: "fade-in",
  });

  useEffect(() => {
    const textInterval = setInterval(() => {
      setFadeProp({ fade: "fade-out" });
      setTimeout(() => {
        setIndex((prevIndex) => (prevIndex + 1) % loadingStateText.length);
        setFadeProp({ fade: "fade-in" });
      }, 300);
    }, 5000);

    return () => clearInterval(textInterval);
  }, []);

  return (
    <div className="analyze-brief-loader">
      <Lottie
        animationData={animationData}
        className="analyze-brief-loader__lottie"
      />
      <div
        className={`text-h6-regular analyze-brief-loader__text ${fadeProp.fade}`}
      >
        {loadingStateText[index]}...
      </div>
    </div>
  );
}
